const ColorThemeOptions = {
  DARK: "DARK",
  LIGHT: "LIGHT",
};

export default ColorThemeOptions;
